/**************************************************************************************************/
/*   File: /src/app/stores/reducers/dossiers/reducer.ts                                           */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Jun 14 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import * as _ from 'lodash';

import * as fromShared from '../../../shared';
import * as fromActions from '../../actions';
import * as fromStates from '../../states';

/**
 * the dossier state reducer
 * @param state The state
 * @param action The action
 */
export function dossiersReducer(
    state: fromStates.fromDossiers.DossiersState = fromStates.fromDossiers.INITIAL_DOSSIERS_STATE,
    action: fromActions.fromDossiers.DossiersActions |
        fromActions.fromMessages.MessagesActions |
        fromActions.fromUi.Actions):
    fromStates.fromDossiers.DossiersState {

    switch (action.type) {
        // Reducer for load dossiers 
        case fromActions.fromDossiers.DossiersActionTypes.LOAD_DOSSIERS_SUMMARIES:
            return {
                ...state,
                isLoading: true
            };
        // Reducer for load dossier success
        case fromActions.fromDossiers.DossiersActionTypes.LOAD_DOSSIERS_SUMMARIES_SUCCESS:
            return {
                ...state,
                dossiers: [
                    ...action.payload.dossiersSummaries
                ],
                isLoading: false
            };
        // Reducer for load dossier fail
        case fromActions.fromDossiers.DossiersActionTypes.LOAD_DOSSIERS_SUMMARIES_FAIL:
            return {
                ...state,
                dossiers: [],
                messages: [
                    action.payload.message
                ],
                isLoading: false
            };
        // Reducer for notify message
        case fromActions.fromMessages.MessagesActionsType.NOTIFY_MESSAGE:
            return action.payload.message.stateName === fromStates.fromDossiers.STATE_NAME ?
                {
                    ...state,
                    messages: [
                        ...state.messages,
                        action.payload.message
                    ]
                } : { ...state };
        // Reducer for message removed
        case fromActions.fromMessages.MessagesActionsType.REMOVE_MESSAGE_ACTION:
            return {
                ...state,
                messages: [...state.messages.filter(x => x !== action.payload.message)]
            };
        case fromActions.fromUi.UiActionTypes.UNSET_LOGGED_USER:
            return {
                ...fromStates.fromDossiers.INITIAL_DOSSIERS_STATE
            };
      
        default:
            return state;
    }
}

// Helpers
/**
 * The get isLoading helper function
 * @param state The state
 */
const getIsLoading = (state: fromStates.fromDossiers.DossiersState) => state.isLoading;
/**
 * The get messages helper function
 * @param state The state
 */
const getMessages = (state: fromStates.fromDossiers.DossiersState) => state.messages;
/**
 * The get dossiers helper function
 * @param state The state
 */
const getDossiers = (state: fromStates.fromDossiers.DossiersState) => state.dossiers;


/**
 * Export the helpers
 */
export const helpers = {
    getIsLoading,
    getMessages,
    getDossiers
};
